import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css, keyframes } from '@emotion/react';
import { Colors } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { Children } from 'react';
import { MEDIA_MIN_WIDTH } from '../../constants';
const resetPos = 'calc(-50% - (var(--ticker-gap) / 2))';
const ticker = keyframes({
    from: {
        transform: 'translate3d(var(--ticker-start), 0, 0)',
    },
    to: {
        transform: 'translate3d(var(--ticker-end), 0, 0)',
    },
});
const Styles = labelStyles('Ticker', {
    root: css({
        width: '100%',
        maxWidth: '1440px',
        margin: '0 auto',
        padding: '16px 0',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        backgroundColor: Colors.neutral100,
        overflow: 'hidden',
        '&[data-compact="true"]': {
            padding: '14px 0',
        },
        [MEDIA_MIN_WIDTH.small]: {
            padding: '24px 0',
            '&[data-compact="true"]': {
                padding: '16px 0',
            },
        },
        [MEDIA_MIN_WIDTH.large]: {
            padding: '48px 0',
            '&[data-compact="true"]': {
                padding: '22px 0',
            },
        },
        '@media (min-width: 1440px)': {
            '&::after': {
                content: '""',
                width: '100%',
                height: '100%',
                position: 'absolute',
                background: `linear-gradient(
          to right,
          rgba(255, 253, 249, 1) 0%,
          rgba(255, 253, 249, 0) 20%,
          rgba(255, 253, 249, 0) 80%,
          rgba(255, 253, 249, 1) 100%
        )`,
            },
        },
    }),
    ticker: css({
        '--ticker-gap': '32px',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--ticker-gap)',
        '@media (prefers-reduced-motion: no-preference)': {
            animation: `${ticker} var(--ticker-duration) linear infinite`,
        },
        [MEDIA_MIN_WIDTH.small]: {
            '--ticker-gap': '48px',
        },
        [MEDIA_MIN_WIDTH.large]: {
            '--ticker-gap': '80px',
            '[data-compact="true"] &': {
                '--ticker-gap': '64px',
            },
        },
        '& > *': {
            flexShrink: 0,
        },
    }),
});
export function Ticker(props) {
    var _a;
    const children = Children.toArray(props.children);
    const duplicatedChildren = [...children, ...children];
    let duration;
    if (props.speed === 'slow') {
        duration = children.length * 7.5;
    }
    else if (props.speed === 'fast') {
        duration = children.length * 2.5;
    }
    else {
        duration = children.length * 5;
    }
    return (_jsx("div", Object.assign({ css: Styles.root, "data-compact": (_a = props.compact) !== null && _a !== void 0 ? _a : false }, { children: _jsx("div", Object.assign({ css: Styles.ticker, style: {
                '--ticker-start': props.reversed ? resetPos : '0',
                '--ticker-end': props.reversed ? '0' : resetPos,
                '--ticker-duration': `${duration}s`,
            } }, { children: duplicatedChildren.map((child, index) => (_jsx("div", Object.assign({ "aria-hidden": index > children.length - 1 }, { children: child }), index))) })) })));
}
//# sourceMappingURL=Ticker.js.map